import React from "react";
import {Box, ButtonBase, Paper, Typography} from "@mui/material";
import {SECOES, completude} from "../sistemaPagina";
import {iconeDaCor} from "./SistemaVisual";

// Coluna ao lado com a completude de cada seção. No celular vira uma faixa rolável acima das seções.
export default function NavegacaoSecoes({sistema, pendencias, secaoAtual, onIr}) {
    return (
        <Box component="nav" aria-label="Seções do sistema" sx={{position: {md: 'sticky'}, top: {md: 88}, alignSelf: 'start', minWidth: 0}}>
            <Paper
                variant="outlined"
                component="ul"
                sx={{
                    listStyle: 'none',
                    m: 0,
                    p: 0.75,
                    display: 'flex',
                    flexDirection: {xs: 'row', md: 'column'},
                    gap: 0.5,
                    overflowX: {xs: 'auto', md: 'visible'},
                }}
            >
                {SECOES.map((secao) => {
                    const c = completude(secao.id, {sistema, pendencias});
                    const atual = secao.id === secaoAtual;
                    return (
                        <Box component="li" key={secao.id} sx={{flexShrink: 0}}>
                            <ButtonBase
                                onClick={() => onIr(secao.id)}
                                aria-current={atual ? 'location' : undefined}
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    gap: 1,
                                    textAlign: 'left',
                                    borderRadius: 1,
                                    px: 1.25,
                                    py: 1,
                                    bgcolor: atual ? 'action.selected' : 'transparent',
                                    '&:hover': {bgcolor: 'action.hover'},
                                }}
                            >
                                <Box sx={{color: c.cor === 'default' ? 'text.disabled' : `${c.cor}.main`, display: 'flex', pt: 0.25}}>{iconeDaCor(c.cor)}</Box>
                                <Box sx={{minWidth: 0}}>
                                    <Typography variant="body2" fontWeight={600} noWrap>{secao.rotulo}</Typography>
                                    <Typography variant="caption" color="text.secondary" component="div" noWrap>{c.texto}</Typography>
                                </Box>
                            </ButtonBase>
                        </Box>
                    );
                })}
            </Paper>
        </Box>
    );
}
